import {
    GET_MAPPING_MASTER_LIST,
    GET_MAPPING_MASTER_LIST_SUCCESS,
    SAVE_MAPPING_MASTER,
    SAVE_MAPPING_MASTER_SUCCESS,
    MAPPING_MASTER_API_ERROR
  } from "./actionType";
  
  // GET LIST
  export const getMappingMasterList = () => ({
    type: GET_MAPPING_MASTER_LIST
  });
  
  export const getMappingMasterListSuccess = (resp) => ({
    type: GET_MAPPING_MASTER_LIST_SUCCESS,
    payload: resp
  });
  
  // SAVE
  export const saveMappingMaster = (config = {}) => ({
    type: SAVE_MAPPING_MASTER,
    config
  });
  
  export const saveMappingMasterSuccess = (resp) => ({
    type: SAVE_MAPPING_MASTER_SUCCESS,
    payload: resp
  });
  
  // ERROR
  export const mappingMasterApiError = () => ({
    type: MAPPING_MASTER_API_ERROR
  });